import { useEffect, useState } from 'react';

import { FormHelp, Textarea } from '@zillow/constellation';

type Props = {
  initialValue?: string;
  isDisabled?: boolean;
  maxLength?: string | number;
  // eslint-disable-next-line
  onClearError?: (value?: any) => void;
  handleCaptionBlur: (value: string) => void;
};

export const TextareaHelper = ({
  initialValue = '',
  isDisabled = false,
  maxLength = 255,
  onClearError,
  handleCaptionBlur,
}: Props) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleOnChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (onClearError) {
      onClearError();
    }
    setValue(e.target.value);
  };

  const handleOnBlur = () => {
    handleCaptionBlur(value);
  };

  return (
    <>
      <Textarea
        aria-label="Image Description"
        marginY="xs"
        placeholder="Describe this photo"
        maxLength={String(maxLength)}
        value={value}
        onChange={handleOnChange}
        onBlur={handleOnBlur}
        disabled={isDisabled}
      />

      <FormHelp>Max {maxLength} characters</FormHelp>
    </>
  );
};
